/* eslint-disable */
import PostFilter from '../classes/postfilter';

export default {
  init() {


    new PostFilter({
       ajaxLoadedCallback: function (container, elems ) {
         // aggiorna il locomotive altrimenti la pagina non scrolla
         window.sf.scrollManager.scroll.update();
      }
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateEventiPassati.js